"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionQueryClient = void 0;
var axios_1 = __importDefault(require("axios"));
var DistributionQueryClient = /** @class */ (function () {
    function DistributionQueryClient(baseUrl) {
        this.axios = axios_1.default.create({
            baseURL: baseUrl,
            headers: {
                Accept: "application/json",
            },
            timeout: 15000,
        });
    }
    DistributionQueryClient.prototype.queryGetRewardInfo = function (address, validatorAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var path, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "/cosmos/distribution/v1beta1/delegators/" + address + "/rewards/" + validatorAddress;
                        return [4 /*yield*/, this.axios.get(path)];
                    case 1:
                        result = _a.sent();
                        if (result.data.rewards.length === 0) {
                            return [2 /*return*/, "0"];
                        }
                        // reward array is very important for refactoring and other functions.
                        return [2 /*return*/, result.data.rewards[0].amount];
                }
            });
        });
    };
    DistributionQueryClient.prototype.queryGetValidatorOutStandingReward = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var path, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "/cosmos/distribution/v1beta1/validators/" + address + "/outstanding_rewards";
                        return [4 /*yield*/, this.axios.get(path)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data.rewards.rewards];
                }
            });
        });
    };
    DistributionQueryClient.prototype.queryGetValidatorCommission = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var path, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "/cosmos/distribution/v1beta1/validators/" + address + "/commission";
                        return [4 /*yield*/, this.axios.get(path)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data.commission.commission];
                }
            });
        });
    };
    DistributionQueryClient.prototype.queryGetTotalRewardInfo = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var path, result, data, finalData, i, amount, tempData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "/cosmos/distribution/v1beta1/delegators/" + address + "/rewards";
                        return [4 /*yield*/, this.axios.get(path)];
                    case 1:
                        result = _a.sent();
                        data = result.data;
                        finalData = {
                            rewards: [],
                            total: ""
                        };
                        for (i = 0; i < data.rewards.length; i++) {
                            amount = "0";
                            if (data.rewards[i].reward.length !== 0) {
                                amount = data.rewards[i].reward[0].amount;
                            }
                            tempData = { validator_address: data.rewards[i].validator_address, amount: amount };
                            finalData.rewards.push(tempData);
                        }
                        ;
                        if (data.total.length > 0) {
                            finalData.total = data.total[0].amount;
                        }
                        return [2 /*return*/, finalData];
                }
            });
        });
    };
    DistributionQueryClient.prototype.queryGetCommunityPool = function () {
        return __awaiter(this, void 0, void 0, function () {
            var path, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "/cosmos/distribution/v1beta1/community_pool";
                        return [4 /*yield*/, this.axios.get(path)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data.pool[0].amount];
                }
            });
        });
    };
    DistributionQueryClient.prototype.queryGetWithdrawAddress = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var path, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "/cosmos/distribution/v1beta1/delegators/" + address + "/withdraw_address";
                        return [4 /*yield*/, this.axios.get(path)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data.withdraw_address];
                }
            });
        });
    };
    return DistributionQueryClient;
}());
exports.DistributionQueryClient = DistributionQueryClient;
